"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.config = exports.TEXT_EDITOR_LANGUAGES = exports.LANGUAGES = void 0;
exports.LANGUAGES = {
    HY: 'hy',
    RU: 'ru',
    EN: 'en',
};
exports.TEXT_EDITOR_LANGUAGES = {
    description: 'hy',
    description_ru: 'ru',
    description_en: 'en',
};
exports.config = {
    language: 'en',
    fontSize_defaultLabel: '0.85rem',
    toolbar: [
        {
            name: 'clipboard',
            items: ['Cut', 'Copy', 'Paste', 'Undo', 'Redo'],
        },
        {
            name: 'basicstyles',
            items: ['Bold', 'Italic', 'Underline', 'Strike', '-'],
        },
    ],
};
